import React, { useEffect, useState } from "react";
import "./LoanPaymentDetails.scss";
import {
  TableHead,
  TableBody,
  Table,
  TableContainer,
  TableCell,
  TableRow,
  Box,
  Pagination,
  Button,
  FormControl,
  Autocomplete,
  TextField,
  Typography,
  Grid,
  Paper,
  TablePagination,
  Accordion, 
  AccordionSummary, 
  AccordionDetails,
  Collapse,
  IconButton,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { styled } from "@mui/material/styles";
import { tableCellClasses } from "@mui/material/TableCell";
import { commonRunQuery } from "../../util/API/loans";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import { CSVLink } from "react-csv";
import pdfImage from "../../images/pdf-image.svg"
import CSVImage from "../../images/csv-file.png";
import jsPDF from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";

const LoanPaymentDetails = ({ paymentId }) => {
    const [loanPage, setLoanPage] = useState(0);
    const [loanRowsPerPage, setLoanRowsPerPage] = useState(5);
    
    const [lateFeePage, setLateFeePage] = useState(0);
    const [lateFeeRowsPerPage, setLateFeeRowsPerPage] = useState(5);
    
    const [customerTabsHeight, setCustomerTabsHeight] = useState(
        window.innerHeight * 0.6
    );
    const [viewPaymentDetails, setViewPaymentDetails] = useState(false);
    const [viewLateFeeDetails, setViewLateFeeDetails] = useState(false);
    const [paymentDetails, setPaymentDetails] = useState([]);
    const [lateFeeDetails, setLateFeeDetails] = useState([]);
    const [lateFeeBreakDown, setLateFeeBreakDown] = useState([]);
    const [expanded, setExpanded] = useState(null);
    const [alert, setAlert] = useState({
        showAlert: false,
        severity: "",
        header: "",
        message: "",
        onConfirm: null,
        alertType: ''
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [loanDetailsArr, setLoanDetailsArr] = useState([]);
    const [selectedLoan, setSelectedLoan] = useState(null);
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [selectedType, setSelectedType] = useState(null);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
        backgroundColor: "rgba(0,0,0, .1)",
        color: theme.palette.common.black,
        fontWeight: "bold",
        textAlign:"center",
        },
        [`&.${tableCellClasses.body}`]: {
        fontSize: 25,
        fontWeight: "600",
        },
    }));

    const handleExpand = (paymentId) => {
        setExpanded(expanded === paymentId ? null : paymentId);
    };

    useEffect(()=> {
        console.log("paymentId===========",paymentId);
        getAppliedLoansDetails();
    },[]);

    const getAppliedLoansDetails = async() => {
        try {
            const response = await commonRunQuery(236, paymentId);
            console.log("handleViewPayment_response==========",response);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const loansArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
        
                setPaymentDetails(loansArray);
                console.log("handleViewPayment_responseeeeee==========",loansArray);
            } else {
                setPaymentDetails([]);
            }

            //  List of payments applied to late fees for a specific payment id
            const lateFeeResponse = await commonRunQuery(238, paymentId);
            if ( lateFeeResponse?.data?.header?.callStatus === "1" && lateFeeResponse?.data?.header?.reccount !== "0" ) {
                const loansArray = Array.isArray(lateFeeResponse?.data?.body?.record)
                        ? lateFeeResponse?.data?.body?.record
                        : [lateFeeResponse?.data?.body?.record];

                setLateFeeDetails(loansArray);
                console.log("lateFeeResponse_responseeeeee==========",loansArray);
            } else {
                setLateFeeDetails([]);
            }
        } catch (error) {
            console.log("getAppliedLoansDetails_error==========",error);
        }
    }

    const handleViewPayment = async(paymentDetails) => {
        console.log("handleViewPayment-------------",paymentDetails?.paymentid);
        try {
        const response = await commonRunQuery(236, paymentDetails?.paymentid);
        if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
            const loansArray = Array.isArray(response?.data?.body?.record)
                    ? response?.data?.body?.record
                    : [response?.data?.body?.record];

            setPaymentDetails(loansArray);
            console.log("handleViewPayment_response==========",loansArray);
        } else {
            setPaymentDetails([]);
        }

        } catch (error) {
        console.log("handleViewPayment_error==========",error);
        
        }
        setViewPaymentDetails(true);
    }

  const handleViewLatePayment = async(feeDetails) => {
    console.log("handleViewLatePayment==========",feeDetails);
    try {
      const response = await commonRunQuery(239, feeDetails?.latefeeid);
      if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
        const loansArray = Array.isArray(response?.data?.body?.record)
        ? response?.data?.body?.record
        : [response?.data?.body?.record];
        console.log("handleViewLatePayment_loansArray==========",loansArray);
        setLateFeeBreakDown(loansArray);
        setViewLateFeeDetails(true);
      } else if (response?.data?.header?.reccount == "0") {
        setLateFeeBreakDown([]);
        setAlert({
          showAlert: true,
          severity: "error",
          message: "No late fee details available.",
          header: "Sorry!",
        });
      } else {
        setLateFeeBreakDown([]);
      }
    } catch (error) {
      console.log("handleViewLatePayment_error==========",error);
    }
  }

  useEffect(()=> {
    console.log("loanDetailsArr-------------",loanDetailsArr);
    // console.log("userLoanPaymentPlans-------------",userLoanPaymentPlans);
  },[loanDetailsArr])

    const handleMenuOpen = (event, loan) => {
        console.log("handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedLoan(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    const handleViewDetails = (type, row) => {
        console.log("handleViewDetails------------", row);
        setSelectedType(type);
        setSelectedPayment(row);
        // setOpenDetailsDialog(true);
        setOpenDetailsDrawer(true);
        // handleMenuClose(); // close the menu
    };

    const handleLoanChangePage = (event, newPage) => {
        setLoanPage(newPage);
    };
      
    const handleLoanChangeRowsPerPage = (event) => {
        setLoanRowsPerPage(parseInt(event.target.value, 10));
        setLoanPage(0);
    };
      
    const handleLateFeeChangePage = (event, newPage) => {
        setLateFeePage(newPage);
    };
      
    const handleLateFeeChangeRowsPerPage = (event) => {
        setLateFeeRowsPerPage(parseInt(event.target.value, 10));
        setLateFeePage(0);
    };

    return (
        <Box
            sx={{
                padding: "0px 22px",
                // marginBottom: "60px",
                height: "calc(75vh - 80px)",
                overflow: "hidden",
                overflowY:"auto"
            }}
            className="loan-details-container"
        >
            {
                viewLateFeeDetails == true ?
                <Box>
                    <Box className="d-flex justify-content-between">
                        <Typography
                        sx={{
                            fontFamily: "'Nunito'",
                            fontStyle: "normal",
                            fontWeight: 500,
                            fontSize: "21.4825px",
                            color: "#3A3A3A",
                        }}
                        className=""
                        >
                        View Late Fee Details
                        </Typography>
                        <Box>
                        <Button
                            className="fs-size-12 paiy-blue text-white"
                            variant="contained"
                            color="primary"
                            onClick={() => setViewLateFeeDetails(false)}
                        >
                            Return
                        </Button>
                        </Box>
                    </Box>
        
                    <Box className="mt-4">
                        {lateFeeBreakDown && lateFeeBreakDown?.length >0 && lateFeeBreakDown.map((lateFee, index) => (
                        <Accordion key={index} className="mb-2 mt-4">
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                            <Typography variant="h6">
                                Apply ID: {lateFee?.loanlatefeesapplied?.applyid} - UGX {lateFee?.loanlatefeesapplied?.amountapplied}
                            </Typography>
                            </AccordionSummary>
                
                            <AccordionDetails>
                            <TableContainer>
                                <Table size="medium">
                                <TableHead>
                                    <TableRow>
                                    <StyledTableCell><strong>Payment ID</strong></StyledTableCell>
                                    <StyledTableCell><strong>Amount Applied</strong></StyledTableCell>
                                    <StyledTableCell><strong>Currency</strong></StyledTableCell>
                                    <StyledTableCell><strong>Status</strong></StyledTableCell>
                                    <StyledTableCell><strong>Action</strong></StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow>
                                    <TableCell align="center">{lateFee?.loanlatefeesapplied.paymentid}</TableCell>
                                    <TableCell align="center">{lateFee?.loanlatefeesapplied.amountapplied}</TableCell>
                                    <TableCell align="center">{lateFee?.loanlatefeesapplied.currcode}</TableCell>
                                    <TableCell align="center">
                                        {lateFee?.loanlatefeesapplied.status}
                                        {/* {lateFee?.loanlatefeesapplied.status === "0" ? "Fully Paid" : lateFee?.loanlatefeesapplied.status === "1" ? "Fully Paid" : "Cancelled"} */}
                                    </TableCell>
                                    <TableCell align="center">
                                        <div>
                                            <Button
                                                className="action-button"
                                                onClick={() => handleViewDetails("latefee",lateFee?.loanlatefeesapplied)}
                                                variant="contained"
                                                size="small"
                                            >
                                                View Details
                                            </Button>
                                        </div>
                                    </TableCell>
                                    </TableRow>
                                </TableBody>
                                </Table>
                            </TableContainer>
                            </AccordionDetails>
                        </Accordion>
                        ))}
                    </Box>
                </Box>
                :
                <Box>        
                    <Box
                        className="mt-4"
                        sx={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "16px",
                        height: "100%",
                        }}
                    >
                        {/* Left Side: Loan Details & Table */}
                        <Box
                            sx={{
                                flex: "1",
                                maxWidth: "50%",
                                overflow: "hidden",
                                padding: "15px",
                                backgroundColor: "white",
                                display: "flex",
                                flexDirection: "column", // Stack loan details & table
                                height: "100%", // Ensure it does not overflow
                            }}
                        >
                            <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginTop: "20px" }}>Loan Payments</Typography>
                            <Box>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Loan Id</StyledTableCell>
                                                <StyledTableCell>Apply Id</StyledTableCell>
                                                <StyledTableCell>Amount Applied</StyledTableCell>
                                                <StyledTableCell>Payment Id</StyledTableCell>
                                                <StyledTableCell>Status</StyledTableCell>
                                                <StyledTableCell>Action</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {
                                            paymentDetails && paymentDetails.length > 0 ? 
                                            (
                                                paymentDetails.slice(loanPage * loanRowsPerPage, loanPage * loanRowsPerPage + loanRowsPerPage).map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center" className="">
                                                            <div>{row?.loanapplied?.loanid}</div>
                                                        </TableCell>
                                                        <TableCell align="center" className="">
                                                            <div>{row?.loanapplied?.applyid}</div>
                                                        </TableCell>
                                                        <TableCell align="right" className="">
                                                            <div>{Number(row?.loanapplied?.amountapplied).toLocaleString("en-US", { minimumFractionDigits: 2 })}</div>
                                                        </TableCell>
                                                        <TableCell align="center" className="">
                                                            <div>{row?.loanapplied?.paymentid}</div>
                                                        </TableCell>
                                                        <TableCell align="center" className="">
                                                            <div>{row?.loanapplied?.status}</div>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <div>
                                                                <Button
                                                                    className="action-button"
                                                                    onClick={() => handleViewDetails("outstandingloan",row?.loanapplied)}
                                                                    variant="contained"
                                                                    size="small"
                                                                >
                                                                    View Details
                                                                </Button>
                                                            </div>
                                                            {/* <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                                                <MoreVertIcon />
                                                            </IconButton> */}
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : 
                                            (
                                                <TableRow>
                                                    <TableCell align="center" colSpan={6}>
                                                        <Typography variant="body1" color="textSecondary">
                                                            No data available
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={paymentDetails?.length || 0}
                                    rowsPerPage={loanRowsPerPage}
                                    page={loanPage}
                                    onPageChange={handleLoanChangePage}
                                    onRowsPerPageChange={handleLoanChangeRowsPerPage}
                                />
                            </Box>
                        </Box>

                        {/* Right Side */}
                        <Box
                        sx={{
                            flex: 1,
                            minWidth: "50%",
                            backgroundColor: "white",
                            overflow: "auto",
                            marginLeft: "15px",
                            height: "100%",
                            padding: "15px",
                        }}
                        >
                        <Typography variant="subtitle1" sx={{ fontWeight: "bold", marginTop: "20px" }}>Late Fee Payment</Typography>
                        <Box>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell>Late Fee Id</StyledTableCell>
                                                <StyledTableCell>Apply Id</StyledTableCell>
                                                <StyledTableCell>Amount Applied</StyledTableCell>
                                                <StyledTableCell>Payment Id</StyledTableCell>
                                                <StyledTableCell>Status</StyledTableCell>
                                                <StyledTableCell>Action</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {
                                            lateFeeDetails && lateFeeDetails.length > 0 ? 
                                            (
                                                lateFeeDetails.slice(lateFeePage * lateFeeRowsPerPage, lateFeePage * lateFeeRowsPerPage + lateFeeRowsPerPage).map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center" className="late-fee-id" onClick={()=>handleViewLatePayment(row?.loanlatefeesapplied)}>
                                                            <div>{row?.loanlatefeesapplied?.latefeeid}</div>
                                                        </TableCell>
                                                        <TableCell align="center" className="">
                                                            <div>{row?.loanlatefeesapplied?.applyid}</div>
                                                        </TableCell>
                                                        <TableCell align="center" className="">
                                                            <div>{row?.loanlatefeesapplied?.amountapplied}</div>
                                                        </TableCell>
                                                        <TableCell align="center" className="">
                                                            <div>{row?.loanlatefeesapplied?.paymentid}</div>
                                                        </TableCell>
                                                        <TableCell align="center" className="">
                                                            <div>{row?.loanlatefeesapplied?.status}</div>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <div>
                                                                <Button
                                                                    className="action-button"
                                                                    onClick={() => handleViewDetails("latefee",row?.loanlatefeesapplied)}
                                                                    variant="contained"
                                                                    size="small"
                                                                >
                                                                    View Details
                                                                </Button>
                                                            </div>
                                                            {/* <IconButton onClick={(e) => handleMenuOpen(e, row)}>
                                                                <MoreVertIcon />
                                                            </IconButton> */}
                                                        </TableCell>
                                                    </TableRow>
                                                ))
                                            ) : (
                                                <TableRow>
                                                    <TableCell align="center" colSpan={6}>
                                                        <Typography variant="body1" color="textSecondary">
                                                            No data available
                                                        </Typography>
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        }
                                    </Table>
                                </TableContainer>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={lateFeeDetails?.length || 0}
                                    rowsPerPage={lateFeeRowsPerPage}
                                    page={lateFeePage}
                                    onPageChange={handleLateFeeChangePage}
                                    onRowsPerPageChange={handleLateFeeChangeRowsPerPage}
                                />
                            </Box>
                        </Box>
                    </Box>
                </Box>
            }

            <div className="loans-details-info-drawer">
                <BaseDrawer
                    open={openDetailsDrawer}
                    handleClose={() => setOpenDetailsDrawer(false)}
                    height="85vh"
                    className="loanProductInfoDrawer"
                    overflow="auto"
                >
                    {selectedPayment && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                    {/* Left Column - Application Info */}
                                    <Box minWidth="300px" flex={1}>
                                    <Typography
                                        sx={{
                                        fontWeight: 800,
                                        color: "#6b7280",
                                        fontFamily: "Nunito",
                                        fontSize: "16px",
                                        }}
                                    >
                                        Application Info
                                    </Typography>

                                    {[
                                        { label: "Apply ID", value: selectedPayment?.applyid },
                                        { label: selectedType=="latefee" ? "Late Fee Id" : "Loan ID", value: selectedType=="latefee" ? selectedPayment?.latefeeid : selectedPayment?.loanid },
                                        { label: "User ID", value: selectedPayment?.userid },
                                        { label: "Payment ID", value: selectedPayment?.paymentid },
                                        { label: "Currency", value: selectedPayment?.currcode },
                                        { label: "Payment Plan ID", value: selectedPayment?.paymentplanid },
                                        { label: "Status", value: selectedPayment?.status },
                                        { label: "Confirmation Time", value: selectedPayment?.confirmationtime || "N/A" },
                                        { label: "Confirmation Ref No", value: selectedPayment?.confirmationrefno || "N/A" },
                                    ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index}>
                                        <Box className="info-type">{label}:</Box>
                                        <Box className="info-response">{value}</Box>
                                        </Box>
                                    ))}
                                    </Box>

                                    {/* Right Column - Amount Breakdown */}
                                    <Box minWidth="300px" flex={1}>
                                    <Typography
                                        sx={{
                                        fontWeight: 800,
                                        color: "#6b7280",
                                        fontFamily: "Nunito",
                                        fontSize: "16px",
                                        }}
                                    >
                                        Amount Breakdown
                                    </Typography>

                                    {[
                                        { label: "Amount Applied", value: selectedPayment?.amountapplied },
                                        selectedType == "latefee" ? null : { label: "Fees Applied", value: selectedPayment?.feesapplied },
                                        selectedType == "latefee" ? null : { label: "Total Amount Applied", value: selectedPayment?.totalamountapplied },
                                        { label: "Tax Breakdown", value: selectedPayment?.taxamountbreakdown },
                                        { label: "System Fee", value: selectedPayment?.feesystembreakdown },
                                        { label: "External Fee", value: selectedPayment?.feeexternalbreakdown },
                                        { label: "Franchisee Fee", value: selectedPayment?.feefranchiseebreakdown },
                                        { label: "Reseller Fee", value: selectedPayment?.feeresellerbreakdown },
                                    ].filter(Boolean).map(({ label, value }, index) => (
                                        <Box className="info-container" key={index}>
                                        <Box className="info-type">{label}:</Box>
                                        <Box className="info-response">{value}</Box>
                                        </Box>
                                    ))}
                                    </Box>

                                </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                </BaseDrawer>
            </div>

            <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="md"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Loan Payment Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedPayment && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>

                                    {/* Left Column - Application Info */}
                                    <Box minWidth="300px" flex={1}>
                                    <Typography
                                        sx={{
                                        fontWeight: 800,
                                        color: "#6b7280",
                                        fontFamily: "Nunito",
                                        fontSize: "16px",
                                        }}
                                    >
                                        Application Info
                                    </Typography>

                                    {[
                                        { label: "Apply ID", value: selectedPayment?.applyid },
                                        { label: selectedType=="latefee" ? "Late Fee Id" : "Loan ID", value: selectedType=="latefee" ? selectedPayment?.latefeeid : selectedPayment?.loanid },
                                        { label: "User ID", value: selectedPayment?.userid },
                                        { label: "Payment ID", value: selectedPayment?.paymentid },
                                        { label: "Currency", value: selectedPayment?.currcode },
                                        { label: "Payment Plan ID", value: selectedPayment?.paymentplanid },
                                        { label: "Status", value: selectedPayment?.status },
                                        { label: "Confirmation Time", value: selectedPayment?.confirmationtime || "N/A" },
                                        { label: "Confirmation Ref No", value: selectedPayment?.confirmationrefno || "N/A" },
                                    ].map(({ label, value }, index) => (
                                        <Box className="info-container" key={index}>
                                        <Box className="info-type">{label}:</Box>
                                        <Box className="info-response">{value}</Box>
                                        </Box>
                                    ))}
                                    </Box>

                                    {/* Right Column - Amount Breakdown */}
                                    <Box minWidth="300px" flex={1}>
                                    <Typography
                                        sx={{
                                        fontWeight: 800,
                                        color: "#6b7280",
                                        fontFamily: "Nunito",
                                        fontSize: "16px",
                                        }}
                                    >
                                        Amount Breakdown
                                    </Typography>

                                    {[
                                        { label: "Amount Applied", value: selectedPayment?.amountapplied },
                                        selectedType == "latefee" ? null : { label: "Fees Applied", value: selectedPayment?.feesapplied },
                                        selectedType == "latefee" ? null : { label: "Total Amount Applied", value: selectedPayment?.totalamountapplied },
                                        { label: "Tax Breakdown", value: selectedPayment?.taxamountbreakdown },
                                        { label: "System Fee", value: selectedPayment?.feesystembreakdown },
                                        { label: "External Fee", value: selectedPayment?.feeexternalbreakdown },
                                        { label: "Franchisee Fee", value: selectedPayment?.feefranchiseebreakdown },
                                        { label: "Reseller Fee", value: selectedPayment?.feeresellerbreakdown },
                                    ].filter(Boolean).map(({ label, value }, index) => (
                                        <Box className="info-container" key={index}>
                                        <Box className="info-type">{label}:</Box>
                                        <Box className="info-response">{value}</Box>
                                        </Box>
                                    ))}
                                    </Box>

                                </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                        Close
                        </Button>
                    </DialogActions>
            </Dialog>

            <CustomAlert
                severity={alert.severity}
                show={alert.showAlert}
                header={alert.header}
                message={alert.message}
                onClick={() => {
                setAlert({ ...alert, showAlert: false });
                }}
                alertType={alert.alertType}
                confirmButton={alert.onConfirm}
                autoclose={alert.severity === "error" ? false : true}
            />
        </Box>
    );
};

export default LoanPaymentDetails;
